export * from './AcceptCookies';
